<div class="container">
  <p-toast/>
  <p-card>
    <div class="inner-container">
      <div class="title">
        <img src="assets/logos/logo_with_text.png" />
      </div>
      <!--<p class="error">RoRender is in Beta testing right now and not open to the public.</p>-->
      <h2>Welcome 👋</h2>
      <p>Please sign into your account with one of our <b><i class="fi fi-rr-lock"></i> Secure Sign In</b> providers</p>
      <div class='buttons'>
        <p-button icon="pi pi-google" label="Google" severity='primary' (click)="loginWithGoogle()"></p-button>
        <p-button icon="pi pi-github" label="Github" severity='info' (click)="loginWithGithub()"></p-button>
        <p-button icon="pi pi-twitter" label="X" severity='contrast' (click)="loginWithTwitter()"></p-button>
      </div>
      <p class="agreement">By signing into RoRender, you agree to our <a href="privacy">Privacy Policy</a> and <a href="tos">Terms of Service</a>.</p>
    </div>
  </p-card>
</div>
